// src/MainMenu.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FlaticonIcon from "components/FlaticonIcon";

import ExpandableNavItem from "components/ExpandableNavItem";
import NavItem from "components/NavItem";

export default function MainMenu({ menuLayout, closeMenuHandler }) {
  const location = useLocation();

  useEffect(() => {
    closeMenuHandler && closeMenuHandler();
  }, [location, closeMenuHandler]);

  return (
    <>
      {/* Group 1: In-app routes (React) */}
      <ExpandableNavItem
        text={menuLayout.MenuItemGroup1}
        icon={<FlaticonIcon icon="briefcase-blank" ext="svg" />}
        isOpen={true}
      >
        <NavItem
          to="/metrics"
          text={menuLayout.MenuItem23}
          icon={<FlaticonIcon icon="dashboard" ext="svg" />}
        />
        <NavItem
          to="/spp"
          text={menuLayout.MenuItem18}
          icon={<FlaticonIcon icon="briefcase" ext="svg" />}
        />
        <NavItem
          to="/sp"
          text={menuLayout.MenuItem17}
          icon={<FlaticonIcon icon="portfolio" ext="svg" />}
        />
        <NavItem
          to="/mtp"
          text={menuLayout.MenuItem15}
          icon={<FlaticonIcon icon="government-budget" ext="svg" />}
        />
        <NavItem
          to="/investmentStreams"
          text={menuLayout.MenuItem16}
          icon={<FlaticonIcon icon="smart-contract" ext="svg" />}
        />
{        <NavItem
          to="/sectoralEvaluation"
          text={menuLayout.MenuItem22}
          icon={<FlaticonIcon icon="audit" ext="svg" />}
        />}
        <NavItem
          to="/expertEvaluation"
          text={menuLayout.MenuItem19}
          icon={<FlaticonIcon icon="assessment" ext="svg" />}
        />
        <NavItem
          to="/pipDetails"
          text={menuLayout.MenuItem20}
          icon={<FlaticonIcon icon="description-alt" ext="svg" />}
        />
        <NavItem
          to="/programDetails"
          text={menuLayout.MenuItem21}
          icon={<FlaticonIcon icon="album-collection" ext="svg" />}
        />
      </ExpandableNavItem>

      {/* Group 2: Cross-app links */}
      <ExpandableNavItem
        text={menuLayout.MenuItemGroup2}
        icon={<FlaticonIcon icon="box" ext="svg" />}
        isOpen={false}
      >

        <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/finPrograms"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon="table-list" />
            </span>
            <p>{menuLayout.MenuItem11}</p>
          </a>
        </li>

        <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/finProgramsDetails"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon="list-ol" />
            </span>
            <p>{menuLayout.MenuItem9}</p>
          </a>
        </li>

        <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/applications"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon="scroll" />
            </span>
            <p>{menuLayout.MenuItem10}</p>
          </a>
        </li>

{/*         <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon="home" />
            </span>
            <p>{menuLayout.MenuItem1}</p>
          </a>
        </li> */}

{/*         <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/projects"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon="layer-group" />
            </span>
            <p>{menuLayout.MenuItem2}</p>
          </a>
        </li> */}

{/*         <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/projectDetails"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon="list" />
            </span>
            <p>{menuLayout.MenuItem3}</p>
          </a>
        </li> */}

{/*         <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/dataAvailability"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon="database" />
            </span>
            <p>{menuLayout.MenuItem6}</p>
          </a>
        </li> */}

{/*         <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/financing"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon="hand-holding-dollar" />
            </span>
            <p>{menuLayout.MenuItem4}</p>
          </a>
        </li>
 */}
{/*         <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/financingDetails"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon="receipt" />
            </span>
            <p>{menuLayout.MenuItem5}</p>
          </a>
        </li> */}

{/*         <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/budget"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon="sack-dollar" />
            </span>
            <p>{menuLayout.MenuItem7}</p>
          </a>
        </li> */}

{/*         <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={
              process.env.REACT_APP_CROSSAPP_LINK + "/#/contractingProcesses"
            }
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FlaticonIcon icon="handshake-deal-loan" ext="svg" />
            </span>
            <p>{menuLayout.MenuItem14}</p>
          </a>
        </li> */}

{/*         <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/investmentProjects"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon="money-bills" />
            </span>
            <p>{menuLayout.MenuItem12}</p>
          </a>
        </li> */}

{/*         <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={
              process.env.REACT_APP_CROSSAPP_LINK +
              "/#/investmentProjectsLocations"
            }
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon="map-location-dot" />
            </span>
            <p>{menuLayout.MenuItem13}</p>
          </a>
        </li> */}

      </ExpandableNavItem>

      {/* If needed later:
      <div className="col-12 as-of-date-disclaimer">
        <p>{menuLayout.}</p>
      </div> */}
    </>
  );
}
